import { render, staticRenderFns } from "./consumerOrderStatistics.vue?vue&type=template&id=2224d34c&scoped=true&"
import script from "./consumerOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./consumerOrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./consumerOrderStatistics.vue?vue&type=style&index=0&id=2224d34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224d34c",
  null
  
)

export default component.exports